import React from 'react';
import { useHistory } from 'react-router-dom';

// Material
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

// Icons
import CloseIcon from '@material-ui/icons/Close';

// Constants
import PATH from 'constants/basePath';

// Styles
import useStyles from './ReportDurableMessage.styles';

interface ReportDurableMessageProps {
  onClose?: () => void;
  onConfirm?: () => void;
}

const ReportDurableMessage: React.FC<ReportDurableMessageProps> = ({
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={`${classes.root} `}>
      <IconButton
        className={classes.closeButton}
        aria-label='Fechar mensagem'
        onClick={onClose}>
        <CloseIcon />
      </IconButton>

      <Typography component='h2' className={classes.title}>
        Necessidade de relatório assíncrono
      </Typography>

      <Typography component='p' className={classes.paragraph}>
        Devido aos filtros selecionados, este relatório possui um volume de
        dados muito grande para ser carregado pelo método padrão.
      </Typography>

      <Typography component='p' className={classes.paragraph}>
        Por esse motivo, ele será processado de forma alternativa e ficará
        disponível para download assim que a geração for concluída. O arquivo
        poderá ser acessado no submódulo de{' '}
        <Link
          component='button'
          type='button'
          className={classes.link}
          onClick={() => history.push(PATH.ASYNCHRONOUS_REPORTS.BASE_URL)}>
          Relatórios Assíncronos
        </Link>
        , localizado dentro do módulo Relatórios.
      </Typography>

      <Typography component='p' className={classes.paragraph}>
        Enquanto o processamento estiver em andamento, você pode continuar
        utilizando o BDOS normalmente ou acompanhar o status do processamento
        diretamente nessa página.
      </Typography>

      <Box className={classes.actions}>
        <Button
          disableElevation
          variant='contained'
          className={classes.confirmButton}
          onClick={onConfirm || onClose}>
          Entendi
        </Button>
      </Box>
    </Box>
  );
};

export { ReportDurableMessage };
export default ReportDurableMessage;
